import React from "react";
import { Box } from "@mui/material";
import UserPageLayout from "../../../components/user/UserPageLayout";
import UserOrganizationView from "../../../components/user/UserOrganizationView";

const Organization = () => {
  return (
    <Box sx={{
      mt: '130px',
      minHeight: 'calc(100vh - 130px)',
      pb: 5,
      px: 2,
      overflow: 'auto',
      height: 'auto',
      maxWidth: 'md',
      mx: 'auto'
    }}>
      <UserPageLayout title="Manage Your Organization">
        <UserOrganizationView />
      </UserPageLayout>
    </Box>
  );
};

export default Organization;
